export default "__VITE_ASSET__DgLufnj6__"